import { useApi } from '../composables/useApi';
import { useStore } from 'vuex';
import { resolveZdhcName } from '../utils/productName';

const SuggestionService = () => 
{
    /* Data */
    const ApiClient = useApi();
    const store = useStore();
    
    /* Methods */
    const storeSuggestion = async (productId, payload) => 
    {
        store.commit('errors/CLEAR_STATE');
        const res = await ApiClient.post(`suggestion/store/${productId}`, payload);
        if(res)
        {
            return res.data;
        }
    };
    const storeSimpleSuggestion = async (productId, zdhcProductId) => 
    {
        store.commit('errors/CLEAR_STATE');
        const res = await ApiClient.post(`suggestion/store-simple-suggestion/${productId}`, zdhcProductId);
        if(res)
        {
            return res;
        }
    };
    const searchSuggestionById = async (id) => 
    {
        store.commit('errors/CLEAR_STATE');
        let matchesArray = [];
        const res = await ApiClient.get(`suggestion/check-for-match/${id}`);
        if(res)
        {
            res.data.results.forEach( p => 
            {
                if(!matchesArray.some(e => e.id === p.zdhc_product.id))
                {
                    matchesArray.push({
                        name: resolveZdhcName(p.zdhc_product.name, store.state.locale),
                        id: p.zdhc_product.id,
                        guid: p.zdhc_product.guid,
                        count: p.count
                    });
                }
            });

            //return res.data;
            return matchesArray;
        }
    };
    const searchSuggestionByName = async (name) => 
    {
        store.commit('errors/CLEAR_STATE');
        let matchesArray = [];
        let encodedName = encodeURIComponent(name);
        const res = await ApiClient.get(`suggestion/search-by-name/${encodedName}`);

        if(res)
        {
            res.data.results.forEach( p => 
            {
                if(!matchesArray.some(e => e.id === p.zdhc_product.id))
                {
                    matchesArray.push({
                        name: resolveZdhcName(p.zdhc_product.name, store.state.locale),
                        id: p.zdhc_product.id,
                        guid: p.zdhc_product.guid,
                        count: p.count
                    });
                }
            });
            return matchesArray;
        }
    };

    return {
        /* Methods */
        storeSuggestion,
        storeSimpleSuggestion,
        searchSuggestionById,
        searchSuggestionByName
    }
};

export default SuggestionService;

